import { render, staticRenderFns } from "./SchoolPreview.vue?vue&type=template&id=bdec7c84&scoped=true&"
import script from "./SchoolPreview.vue?vue&type=script&lang=js&"
export * from "./SchoolPreview.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPreview.vue?vue&type=style&index=0&id=bdec7c84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec7c84",
  null
  
)

export default component.exports